<div class="component-container xs:p-[2rem] sm:p-[1rem] md:p-[2.7rem]">
  <div class="filter-section">
    <app-manage-users-filter></app-manage-users-filter>
  </div>
  <div class="table-section">
    <mat-expansion-panel
      [expanded]="true"
      class="mat-elevation-z0 expansion-panel w-full">
      <mat-expansion-panel-header class="bg-black-100 expansion-panel-header justify-center">
        <div class="title text-cool-grey font-poppins font-semibold text-[1.6rem]">
          Users
        </div>
        <app-primary-button
          *ngIf="!isDrilldown"
          class="lg:w-[14%] xs:w-[35%] sm:w-[35%] md:w-[20%]"
          type="small"
          (handleClick)="OnInvite()"
        >
          Invite User
        </app-primary-button>
      </mat-expansion-panel-header>
      <app-manage-users-table></app-manage-users-table>
    </mat-expansion-panel>

  </div>
</div>
